import * as Yup from 'yup';
import copy from '../copy';
import { replaceInterpolatedVariables } from './string-utils';

export const VALIDATION = {
  PASSWORD: {
    MIN: 8,
    MAX: 72,
    UNIQUE: 6,
  },
  VERIFICATION: {
    DIGITS: 6,
    LONG_CHAR: 8,
  },
};

export const validationCopy = replaceInterpolatedVariables({ VALIDATION }, copy.form);

export const yupPasswordValidation = Yup.string()
  .required(validationCopy.validation.password_required)
  .min(VALIDATION.PASSWORD.MIN, validationCopy.validation.password_min)
  .max(VALIDATION.PASSWORD.MAX, validationCopy.validation.password_max)
  .test(
    'valid',
    validationCopy.validation.password_unique,
    (str) =>
      str &&
      [...str].filter((char, i, sArr) => {
        return sArr.indexOf(char) === i;
      }).length >= VALIDATION.PASSWORD.UNIQUE,
  );

export const yupVerificationCharValidationFn = (long = false): Yup.StringSchema<string> => {
  return Yup.string()
    .required(validationCopy.validation.code_required)
    .matches(
      new RegExp(`^[0-9|a-f]{${long ? VALIDATION.VERIFICATION.LONG_CHAR : VALIDATION.VERIFICATION.DIGITS}}$`),
      long ? validationCopy.validation.code_character_long : validationCopy.validation.code_character,
    );
};

export const yupVerificationNumberValidation = Yup.string()
  .required(validationCopy.validation.code_required)
  .matches(new RegExp(`^[0-9]{${VALIDATION.VERIFICATION.DIGITS}}$`), validationCopy.validation.code_digit);
